import React from 'react';
import { Flex,Image, HStack, Text, Heading, VStack, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, Box } from '@chakra-ui/react';
import { FaDashcube, FaHome, FaInfoCircle, FaLock, FaPhone, FaPhotoVideo, FaSignOutAlt } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import sls from '../images/sls.png'
import { MdMenu } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { signOut } from '../redux/userSlice';
const Header = () => {

  const {currentUser} = useSelector((state)=>state.user);
  const dispatch = useDispatch();
 const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure()

    const headerStyle = {
        backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)' // Adjust the pixel value as needed
      };

      const handleSignout = ()=>{

        dispatch(signOut());
        navigate('/');

        }
        

  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      borderBottom="1px solid"
      borderColor="gray.200"
      position="fixed" 
      top="0"         
      w="full"        
      zIndex="1" style={headerStyle} 
    >
        
      <HStack>
      <Link to="/">
       <Image src={sls} h={32} w={32}/>
      </Link>
      <VStack spacing={-8}>
      <Heading>SLS Memorial Public School</Heading>
       <Text display={['none','inline-block']}>Budina kalan ,Muzaffarnagar</Text>
      </VStack>
      </HStack>
      {/* Navigation links */}
      <Flex display={{ base: 'none', md: 'flex' }} mr={8} fontSize={'xl'} align="center">
        {currentUser?.isAuthenticated?(<Link to='/dashboard'><HStack mx={4} className='navlink'><FaDashcube /> <Text>Dashboard</Text></HStack> </Link>):(<></>)}
        <Link to='/aboutus'><HStack mx={4} className='navlink'><FaInfoCircle /> <Text>About Us</Text></HStack> </Link>
        <Link to='/gallery'><HStack mx={4} className='navlink'>< FaPhotoVideo/> <Text>Gallery</Text></HStack> </Link>
        <Link to='/contact'><HStack mx={4} className='navlink'><FaPhone /> <Text>Contact Us</Text></HStack> </Link>
       {currentUser?.isAuthenticated?(
       <HStack mx={4} className='navlink' onClick={handleSignout}><FaSignOutAlt color='orange'/><Text>Logout</Text></HStack>
       ):(
        <Link to='/logindashboard'><HStack mx={4} className='navlink'><FaLock color='orange'/> <Text>Portal Login</Text></HStack> </Link>
       )}
        
       
      </Flex>
      {/* Hamburger menu for mobile */}
     <Box mr={4} display={['flex','none']}>
      <MdMenu size={28} onClick={onOpen}  />
      </Box> 

      <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader><Image src={sls} h={16} w={16}/></DrawerHeader>

          <DrawerBody>
            <VStack spacing={12} onClick={onClose}>
          <Link to='/'><HStack mx={4}  className='navlink'><FaHome /> <Text>Home</Text></HStack> </Link>
          <Link to='/aboutus'><HStack mx={4}  className='navlink'><FaInfoCircle /> <Text>About Us</Text></HStack> </Link>
        <Link to='/gallery'><HStack mx={4} className='navlink'>< FaPhotoVideo/> <Text>Gallery</Text></HStack> </Link>
        <Link to='/contact'><HStack mx={4} className='navlink'><FaPhone /> <Text>Contact Us</Text></HStack> </Link>
        <Link to='/logindashboard'><HStack mx={4} className='navlink'><FaLock color='orange'/> <Text>Portal Login</Text></HStack> </Link>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

    </Flex>
  );
};

export default Header;
